<template>
  <div>
    <div class="d-flex">
      <nav id="breadcrumbs" class="mb-3">
        <ul>
          <li>
            <router-link :to="{ name: 'company.dashboard' }">
              <a href="#"> <i class="uil-home-alt"></i> </a>
            </router-link>
          </li>
          <li>
            <span> {{
              this.$t('report.company_dashboard.reports')
            }}
            </span>
          </li>
          <li>{{ $t('general.survey_reports') }}</li>
        </ul>
      </nav>
    </div>

    <div class="section-header mb-lg-2 border-0 uk-flex-middle">
      <div class="section-header-left">
        <h2 class="uk-heading-line text-left">
          <span> {{ $t('general.survey_answer_reports') }} </span>
        </h2>
      </div>
    </div>
    <div v-if="error" class="uk-alert-danger mb-3" uk-alert>
      <a class="uk-alert-close" uk-close></a>
      <p style="color:red;">
        <i class="uil-exclamation-triangle"></i> {{ error }}
      </p>
    </div>
    <div class="card">
      <!-- Card header -->
      <div class="card-header actions-toolbar border-0">
        <div class="d-flex justify-content-between align-items-center">
          <div class="row" style="width:100%">
            <div class=" col-md-1  search-icon ">
              <i class="uil-search"></i>
            </div>
            <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
              <input v-model="filter.search" :placeholder="$t('general.search')" autofocus=""
                class="uk-search-input shadow-0 uk-form-small" type="search" />
            </div>
          </div>
          <div class="d-flex">
            <a :uk-tooltip="$t('filters.order.sort')" aria-expanded="false" class="btn btn-icon btn-hover  btn-circle"
              href="javascript:void(0)" title="">
              <i class="uil-list-ui-alt"></i>
            </a>
            <div class="uk-dropdown" uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up">
              <ul class="uk-nav uk-dropdown-nav">
                <li class="uk-active">
                  <a href="javascript:void(0)" @click="sortOrder('asc', 'survey_name')">{{ $t("sorting.a_z") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('desc', 'survey_name')">{{ $t("sorting.z_a") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('asc', 'id')">
                    {{ $t("sorting.created_at_old") }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)" @click="sortOrder('desc', 'id')">
                    {{ $t("sorting.created_at_new") }}</a>
                </li>
              </ul>
            </div>
            <!-- Filter -->
            <a :uk-tooltip="$t('general.filter_list')" class="btn btn-icon btn-hover btn-circle"
              href="javascript:void(0)">
              <i class="uil-filter"></i>
            </a>
            <UserFilter :surveyList="surveyList" :has-status="true" :is-user-active="true" :reportSurvey="true"
              :isDate="false" @getFilter="getFilter($event)" />
            <div class="uk-inline">
              <excel-download-button :loading="isReportDownloading" :tooltipText="$t('filters.export_excell')" />

              <div class="uk-dropdown" uk-dropdown="mode: click; pos: bottom-right; animation: uk-animation-scale-up">
                <ul class="uk-nav uk-dropdown-nav">
                  <li>
                    <a href="javascript:;" @click="exportSurveyResults(null)">
                      {{ $t('general.regular_report') }}
                    </a>
                  </li>
                  <li>
                    <a href="javascript:;" @click="exportSurveyResults('average')">
                      {{ $t('general.cumulative_report') }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Table -->
      <default-loading v-if="tableLoading"></default-loading>

      <template v-else>
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
              <tr>
                <th scope="col">{{ $t("users.photo") }}</th>
                <th scope="col">{{ $t('general.first_name_and_last_name') }}</th>
                <th scope="col">{{ $t("users.user_email") }}</th>
                <th scope="col">{{ $t('general.user_status') }}</th>
                <th scope="col">{{ $t("general.corporation") }}</th>
                <th scope="col">{{ $t('general.register_number') }}</th>
                <th scope="col">{{ $t('general.assignment_name') }}</th>
                <th scope="col">{{ $t('general.survey_name') }}</th>
                <th scope="col">{{ $t('general.question') }}</th>
                <th scope="col">{{ $t('general.answer') }}</th>
                <th scope="col">{{ $t('general.answer_point') }}</th>
                <th scope="col">{{ $t('general.average_point') }}</th>
              </tr>
            </thead>
            <tbody class="list">
              <template v-for="item in formattedItems">
                <tr>
                  <th scope="row">
                    <div class="media align-items-center">
                      <div>
                        <div class="avatar-parent-child" style="width: max-content">
                          <AvatarOrIcon :alt="item.name" :src="item.photo_link" :size-px="32" />
                        </div>
                      </div>
                    </div>
                  </th>
                  <td>{{ item.name }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.status }}</td>
                  <td>{{ item.corporateName }}</td>
                  <td>{{ item.registration_number }}</td>
                  <td>{{ item.assignment_name }}</td>
                  <td>{{ item.surveyName }}</td>
                  <td>{{ item.questionText }}</td>
                  <td>{{ item.answerText }}</td>
                  <td>{{ item.point }}</td>
                  <td>{{ item.average?.toFixed(0) ?? 0 }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <pagination :pagination="pagination" class="mt-2 mb-3" @changePage="setPage($event)"></pagination>
      </template>
    </div>
  </div>
</template>

<script>
import reports, {
  GET_ITEMS,
  MODULE_NAME,
  SUCCESS,
} from "@/core/services/store/reports.module";

import store from "@/core/services";
import moment from "moment";
import axios from "axios";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import Pagination from "@/assets/components/Pagination";
import AvatarOrIcon from "@/view/components/icons/AvatarOrIcon.vue";
import ExcelDownloadButton from "@/view/components/buttons/ExcelDownloadButton.vue";
import UserFilter from "@/view/company/User/Filter";
import {
  getAssignedCorporateAccess,
  applyAssignedCorporateToFilter,
} from "@/core/services/userCorporateAccess.service";
const _MODULE_NAME = MODULE_NAME;

export default {
  name: "ReportSurveyResults",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, reports);
  },
  components: { ExcelDownloadButton, Pagination, DefaultLoading, AvatarOrIcon, UserFilter },
  data() {
    return {
      pagination: null,
      user_ids: [],
      assignment_id: null,
      page: 1,
      per_page: 10,
      formattedItems: [],
      surveyList: [],
      tableLoading: false,
      error: null,
      filter: {
        search: null,
        order: "desc",
        sort: "id",
      },
      isReportDownloading: false,
      keepFilter: null,
      from_date: null,
      to_date: null,
    };
  },
  computed: {
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
  },
  methods: {
    // Filtredeki anket (eğitim) listesini doldurur
    getAssignments() {
      let selectedUserIds = [];

      if (this.user_ids.length > 0) {
        const hasAll = this.user_ids.some(item => item.id === 'all');

        selectedUserIds = hasAll
          ? []
          : this.user_ids.map(item => item.id);
      }

      let filters = {
        page: 0,
        sort: "id",
        order: "desc",
        user_ids: JSON.stringify(selectedUserIds),
        survey: 1,
      };
      store
        .dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
          url: "api/report/get-assignments",
          filters: filters,
        })
        .then((response) => {
          if (response.status) {
            let results = [];
            let items = response.data;
            items.forEach((item) => {
              results.push({
                id: item.id,
                name: item.full_name,
                order_number: item.order_number,
              });
            });
            this.surveyList = results;

            if (results.length === 1) {
              this.assignment_id = results[0];
            }
          }
        });
    },
    getFilter(value) {
      this.page = 1
      this.filterResult(value);
    },
    exportSurveyResults(reportType = null) {

      if (this.isReportDownloading) {
        return;
      }

      if (reportType === 'average' && !this.assignment_id) {
        this.error = this.$t("general.select_education_for_cumulative_report");
        return;
      }
      this.isReportDownloading = true;

      let selectedUserIds = null;

      if (this.user_ids.length > 0) {
        const hasAll = this.user_ids.some(item => item.id === 'all');

        selectedUserIds = hasAll
          ? []
          : this.user_ids.map(item => item.id);
      }
      this.isReportDownloading = true;
      let filters = {
        like: this.filter.search,
        page: this.page,
        per_page: this.per_page,
        sort: this.filter.sort,
        order: this.filter.order,
        assignment_id: this.assignment_id || null
      };
      if (this.keepFilter) {
        const keepFilter = this.keepFilter;

        if (keepFilter.company_id) {
          filters['company_id'] = keepFilter.company_id;
        }

        // {id, name} listesi tutan filtreler API için id dizisine çevrilir
        Object.entries(keepFilter).forEach(([key, value]) => {
          if (!Array.isArray(value) || key === 'company_id') return;

          let ids = value.map((item) => item.id);

          // "Tümü" seçiliyse (id null) assignment_id gönderilmez
          if (key === 'assignment_id' && value.some((assignment) => assignment?.id === null)) {
            ids = null;
          }

          if (ids?.length > 0) {
            filters[key] = JSON.stringify(ids);
          }
        });
      }
      let export_user_ids = selectedUserIds !== null ? JSON.stringify(selectedUserIds) : null;
      let url = `${process.env.VUE_APP_BACKEND_APP_URL}/api/report/export/user-survey-results?`;
      url += `&user_ids=${export_user_ids}`;
      url += `&sort=${filters.sort}`;
      url += `&order=${filters.order}`;
      if (filters.assignment_id?.length > 0)
        url += `&assignment_ids=${filters.assignment_id}`;
      if (this.keepFilter?.user_id) {
        url += `&user_ids=${JSON.stringify(this.keepFilter.user_id)}`;
      }
      if (filters.branch_id) url += `&branch_id=${filters.branch_id}`;
      if (filters.department_id) url += `&department_id=${filters.department_id}`;
      if (filters.region_id) url += `&region_id=${filters.region_id}`;
      if (filters.title_id) url += `&title_id=${filters.title_id}`;
      if (filters.group_id) url += `&group_id=${filters.group_id}`;
      if (filters.position_id) url += `&position_id=${filters.position_id}`;
      if (filters.corporate_id) url += `&corporate_id=${filters.corporate_id}`;
      if (this.from_date) url += `&from_date=${this.from_date}`;
      if (this.to_date) url += `&to_date=${this.to_date}`;
      if (filters.company_id) url += `&company_id=${filters.company_id}`;
      url += `&report=${Math.random() * 9999999}`;
      if (reportType) {
        url += `&report_type=${reportType}`;
      }
      axios
        .get(
          url,
          {
            responseType: "blob",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.secureLocalStorage("token"),
            },
          }
        )
        .then((response) => {
          let fileURL = window.URL.createObjectURL(new Blob([response.data]));
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          let day = moment().format("YYYYMMDDHHMMSS");
          let suffix = (reportType === 'average') ? '_cumulative' : '';
          let fileName = "survey_result_report_list_" + day + suffix + ".xlsx";
          fileLink.setAttribute("download", fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          window.URL.revokeObjectURL(fileURL);
          this.isReportDownloading = false;
        })
        .catch(() => {
          this.isReportDownloading = false;
        });
    },
    filterResult(filter = null) {
      this.error = null;
      this.tableLoading = true;

      // Yeni filtre geldiyse sakla; gelmediyse (sayfalama, sıralama, yenileme)
      // en son uygulanan filtreyle devam et
      if (filter) {
        this.keepFilter = filter;
        this.assignment_id = filter.assignment_id;
        this.from_date = filter.from_date;
        this.to_date = filter.to_date;
        this.user_ids = Array.isArray(filter.user_id) ? [...filter.user_id] : [];
      }

      let filters = {
        like: this.filter.search,
        page: this.page,
        per_page: this.per_page,
        sort: this.filter.sort,
        order: this.filter.order,
        assignment_id: JSON.stringify(this.assignment_id),
      };

      // İstek her zaman saklanan son filtreden (keepFilter) kurulur
      const activeFilter = this.keepFilter || {};

      if (activeFilter.company_id) {
        filters['company_id'] = activeFilter.company_id;
      }

      // {id, name} listesi tutan filtreler API için id dizisine çevrilir
      Object.entries(activeFilter).forEach(([key, value]) => {
        if (!Array.isArray(value) || key === 'company_id') return;

        let ids = value.map((item) => item.id);

        // "Tümü" seçiliyse (id null) assignment_id gönderilmez
        if (key === 'assignment_id' && value.some((assignment) => assignment?.id === null)) {
          ids = null;
        }

        filters[key] = JSON.stringify(ids);
      });

      this.from_date ? filters['from_date'] = this.from_date : null
      this.to_date ? filters['to_date'] = this.to_date : null
      if (this.user_ids && this.user_ids.length > 0) {
        filters['user_ids'] = JSON.stringify(this.user_ids);
      };
      store
        .dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
          url: "api/report/user-survey-results",
          filters: filters,
        })
        .then((response) => {
          this.tableLoading = false;
          if (response.status) {
            let results = [];
            let items = response.data;
            this.pagination = items;
            items.data.forEach((item) => {
              results.push({
                name: item.user.fullname,
                email: item.user.email,
                status: +item.user.status_id === 0 ? this.$t("general.passive") : this.$t("general.active"),
                corporateName: item.user?.corporate?.name || "-",
                registration_number: item.user.registration_number ?? "-",
                photo_link: item.user.photo_link,
                questionText: item.question_text,
                assignment_name: item.resultable?.name ?? '-',
                surveyName: item.survey?.name,
                answerText: item.question_answer,
                answer: item.question_answer,
                point: item.point,
                average: item.average,
              });
            });
            this.formattedItems = results;
          }
        }).catch(() => {
          this.tableLoading = false;
        });
    },
    sortOrder(order, sort) {
      this.page = 1;
      this.filter.order = order;
      this.filter.sort = sort;

      this.filterResult();
    },
    setPage(page) {
      this.page = page;
      this.filterResult();
    },
  },
  async mounted() {
    this.getAssignments();
    this.debouncedFilterSearch = _.debounce(this.filterResult, 500);

    // company_admin değilse ve bir şirkete atanmışsa
    // ilk yüklemede sadece o şirketin verisi gelsin
    const corporateAccess = await getAssignedCorporateAccess();
    this.keepFilter = applyAssignedCorporateToFilter(this.keepFilter, corporateAccess);

    this.filterResult();
  },
  watch: {
    success: function (val) {
      if (val) {
        this.filterResult();
      }
    },
    "filter.search": function () {
      this.debouncedFilterSearch();
    },
  },
};
</script>

<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.uk-alert {
  margin: 0;
}
</style>
